/* ============================================================
   Ti Solèy Création — Theme JavaScript
   Vanilla JS, aucune dépendance. Chargé en defer.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Announce bar rotation ---- */
  function initAnnounceBar() {
    const bar = document.querySelector('.ts-announce');
    if (!bar) return;
    const spans = bar.querySelectorAll('span');
    if (spans.length < 2) return;
    let idx = 0;
    setInterval(function () {
      spans[idx].classList.remove('ts-on');
      idx = (idx + 1) % spans.length;
      spans[idx].classList.add('ts-on');
    }, 3800);
  }

  /* ---- Header scroll shrink + back-to-top ---- */
  function initHeaderScroll() {
    const header = document.querySelector('.ts-header');
    const totop  = document.getElementById('ts-totop');
    if (!header) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var y = window.scrollY;
          header.classList.toggle('ts-scrolled', y > 20);
          if (totop) totop.classList.toggle('ts-show', y > 600);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    if (totop) {
      totop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  /* ---- Scroll reveal ---- */
  function initScrollReveal() {
    if (window.gsap) return; // GSAP gère les révélations
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ts-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('[data-ts-reveal]').forEach(function (el, i) {
      el.style.setProperty('--ts-delay', (i % 4 * 60) + 'ms');
      io.observe(el);
    });
  }

  /* ---- Mobile menu ---- */
  function initMobileMenu() {
    var overlay = document.getElementById('ts-overlay');
    var menu    = document.getElementById('ts-mobile-menu');
    var openBtn = document.getElementById('ts-open-menu');
    if (!menu || !overlay) return;

    function openMenu() {
      menu.classList.add('ts-open');
      overlay.classList.add('ts-open');
      document.body.classList.add('ts-locked');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    }
    function closeMenu() {
      menu.classList.remove('ts-open');
      overlay.classList.remove('ts-open');
      document.body.classList.remove('ts-locked');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    }

    if (openBtn) openBtn.addEventListener('click', openMenu);
    overlay.addEventListener('click', closeMenu);
    menu.querySelectorAll('[data-ts-close]').forEach(function (btn) {
      btn.addEventListener('click', closeMenu);
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    /* Accordion submenu */
    menu.querySelectorAll('.ts-mm-acc').forEach(function (acc) {
      acc.addEventListener('click', function () {
        var sub    = acc.nextElementSibling;
        var isOpen = acc.classList.contains('ts-open');
        acc.classList.toggle('ts-open', !isOpen);
        sub.style.maxHeight = isOpen ? '' : sub.scrollHeight + 'px';
      });
    });
  }

  /* ---- Wishlist (localStorage) ---- */
  function initWishlist() {
    var KEY = 'ts_wishlist';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}

    function save()   { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
    function refresh() {
      document.querySelectorAll('.ts-wish').forEach(function (btn) {
        var id = btn.dataset.productId;
        var on = list.indexOf(id) !== -1;
        btn.classList.toggle('ts-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var label = on ? 'Retirer des favoris' : 'Ajouter aux favoris';
        btn.setAttribute('aria-label', label);
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ts-wish');
      if (!btn) return;
      var id = btn.dataset.productId;
      if (!id) return;
      var idx = list.indexOf(id);
      if (idx === -1) list.push(id); else list.splice(idx, 1);
      save();
      refresh();
    });

    refresh();
  }

  /* ---- Shipping progress bar (injectée dans le cart drawer Dawn) ---- */
  function initShippingBar() {
    /* On attend que Dawn ait rendu le cart drawer */
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    /* Seuil en centimes, lu depuis l'attribut data-threshold posé par le thème */
    var barEl = document.getElementById('ts-ship-bar');
    var threshold = barEl ? parseInt(barEl.dataset.threshold || '9800', 10) : 9800;

    function updateBar() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!barEl) return;
          var fill = barEl.querySelector('.ts-ship-fill');
          var msg  = barEl.querySelector('.ts-ship-msg');
          var total = cart.total_price;
          var pct   = Math.min(100, Math.round(total / threshold * 100));
          if (fill) fill.style.width = pct + '%';
          if (msg) {
            if (total >= threshold) {
              msg.innerHTML = 'Livraison offerte débloquée ✦';
            } else {
              var rem = Math.ceil((threshold - total) / 100);
              msg.innerHTML = 'Plus que <b>' + rem + ' €</b> pour la livraison offerte';
            }
          }
        })
        .catch(function () {});
    }

    /* Écoute les événements du cart drawer Dawn */
    document.addEventListener('cart:refresh',       updateBar);
    document.addEventListener('cart-drawer:open',   updateBar);
    document.querySelectorAll('[aria-controls="CartDrawer"]').forEach(function (btn) {
      btn.addEventListener('click', function () { setTimeout(updateBar, 200); });
    });
    updateBar();
  }

  /* ---- Add-to-cart via Fetch (pour les cartes produit simple variante) ---- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ts-add]');
      if (!btn) return;
      var variantId = btn.dataset.tsAdd;
      if (!variantId) return;

      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = '…';

      fetch(window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          /* Rafraîchit le cart drawer Dawn */
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) { drawer.renderContents({ cart: cart }); });
          }
          /* Ouvre le tiroir */
          var drawerEl = document.getElementById('CartDrawer');
          if (drawerEl) drawerEl.dispatchEvent(new CustomEvent('cart-drawer:open'));
          var openBtn = document.querySelector('[aria-controls="CartDrawer"]');
          if (openBtn) openBtn.click();

          btn.textContent = '✓';
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1500);
        })
        .catch(function () {
          btn.textContent = orig;
          btn.disabled = false;
        });
    });
  }

  /* ---- Popup bienvenue ---- */
  function initPopup() {
    var overlay = document.getElementById('ts-popup');
    if (!overlay) return;

    var KEY = 'ts_popup_v1';
    try {
      var stored = localStorage.getItem(KEY);
      if (stored && Date.now() < parseInt(stored, 10)) return;
    } catch (e) {}

    var delay = (parseInt(overlay.dataset.delay || '8', 10)) * 1000;

    function open() {
      overlay.style.display = 'grid';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          overlay.classList.add('ts-open');
        });
      });
      document.body.classList.add('ts-locked');
    }

    function close() {
      overlay.classList.remove('ts-open');
      document.body.classList.remove('ts-locked');
      setTimeout(function () { overlay.style.display = 'none'; }, 460);
      try { localStorage.setItem(KEY, String(Date.now() + 30 * 24 * 60 * 60 * 1000)); } catch (e) {}
    }

    /* ═══════════════════════════════════════════════════════════
       LA POP-UP ATTEND UN SIGNE, ELLE NE COMPTE PLUS LES SECONDES

       Elle partait sur un simple minuteur de huit secondes. Deux problèmes,
       et le premier ne se voit que sur un rapport de performance.

       1. LE LCP. Une pop-up est, de loin, le plus grand bloc de la page :
          35 000 px² contre 8 400 pour le titre du héros. Surgie seule à la
          huitième seconde, c'est ELLE que le navigateur retenait comme
          « plus grand affichage de contenu ». Mesuré : 9540 ms, quand la
          page s'affiche en 436. Or le LCP se fige à la première interaction
          de la visiteuse. En attendant un geste avant de lancer le
          minuteur, la pop-up ne peut plus jamais être l'élément LCP.

       2. LA POLITESSE. On ne sollicite pas quelqu'un qui vient d'arriver et
          n'a encore rien regardé. Le minuteur démarre au premier défilement,
          au premier doigt, à la première touche.
       ═══════════════════════════════════════════════════════════ */
    var timer = null, amorce = false;
    var GESTES = ['scroll', 'pointerdown', 'keydown', 'touchstart'];
    var OPTS = { passive: true };
    function amorcer() {
      if (amorce) return;
      amorce = true;
      GESTES.forEach(function (t) { window.removeEventListener(t, amorcer, OPTS); });
      timer = setTimeout(open, delay);
    }
    GESTES.forEach(function (t) { window.addEventListener(t, amorcer, OPTS); });

    var closeBtn = document.getElementById('ts-popup-close');
    if (closeBtn) closeBtn.addEventListener('click', close);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function handler(e) {
      if (e.key === 'Escape' && overlay.classList.contains('ts-open')) {
        close();
        document.removeEventListener('keydown', handler);
      }
    });

    /* ═══ L'ENVOI DE L'E-MAIL ═══
       Ce bloc fermait la pop-up 1,2 s après le clic — et la fermeture la
       marque « refusée » pour 30 jours. Or Shopify vérifie d'abord que la
       visiteuse n'est pas un robot (hCaptcha, obligatoire : un envoi sans
       vérification reçoit un 403). Quand cette vérification dure plus d'une
       seconde, ou qu'un petit défi s'affiche, la pop-up disparaissait sous
       ses yeux : elle pensait l'inscription faite, ou cassée, et ne revoyait
       pas l'offre avant un mois. Constaté : défi affiché, pop-up fermée,
       aucune inscription. Désormais la pop-up reste ouverte, le bouton dit
       qu'il travaille, et c'est le rechargement de Shopify
       (…?customer_posted=true) qui la rouvre sur le code. */
    var form = document.getElementById('ts-popup-form');
    if (form) {
      form.addEventListener('submit', function () {
        clearTimeout(timer);
        var b = form.querySelector('[type=submit], button');
        if (b && !b.getAttribute('data-ts-label')) {
          b.setAttribute('data-ts-label', b.textContent);
          b.textContent = 'Envoi…';
          b.setAttribute('aria-busy', 'true');
          /* Si la visiteuse referme le défi sans le résoudre, le bouton
             retrouve son libellé : rien ne reste bloqué sur « Envoi… ». */
          setTimeout(function () {
            if (!b.getAttribute('data-ts-label')) return;
            b.textContent = b.getAttribute('data-ts-label');
            b.removeAttribute('data-ts-label');
            b.removeAttribute('aria-busy');
          }, 15000);
        }
      });
    }
  }

  /* ═══════════════════════════════════════════════════════
     GSAP — animations avancées (chargé via CDN avant ce fichier)
  ═══════════════════════════════════════════════════════ */
  function initGSAP() {
    if (!window.gsap) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    gsap.registerPlugin(ScrollTrigger);
    gsapHero();
    gsapStars();
    gsapScrollReveal();
    gsapProducts();
    gsapParallax();
    gsapSections();
  }

  /* Entrée orchestrée du hero */
  function gsapHero() {
    /* Hero révélation scroll-driven : CSS + vanilla JS inline dans la section */
    if (document.querySelector('.ts-hero-reveal')) return;
    /* Hero split atelier */
    if (document.querySelector('.ts-hero-split')) { gsapHeroSplit(); return; }
    if (!document.querySelector('.ts-hero')) return;
    document.body.classList.add('gsap-ready');
  }

  function gsapHeroSplit() {
    document.body.classList.add('gsap-ready');
    var ease = 'power3.out';
    var tl   = gsap.timeline({ delay: 0.08 });

    /* Photo gauche : glisse depuis la gauche avec légère perspective */
    tl.fromTo('.ts-hs-media',
        { opacity: 0, x: -70, rotationY: 6 },
        { opacity: 1, x: 0,  rotationY: 0, duration: 1.1, ease: 'power2.out',
          transformPerspective: 900 })

    /* Séparateur fil jute : se trace du haut vers le bas */
      .fromTo('.ts-hs-divider',
        { scaleY: 0, transformOrigin: 'top center' },
        { scaleY: 1, duration: 0.85, ease: 'power2.inOut' }, '-=0.6')

    /* Étiquette kraft : tombe avec rebond */
      .fromTo('#ts-hs-tag',
        { y: -80, opacity: 0, rotation: -12 },
        { y: 0,   opacity: 1, rotation:  0,  duration: 0.85, ease: 'back.out(2)' }, '-=0.4')

    /* Herbes séchées : balayent depuis la droite */
      .fromTo('#ts-hs-grass',
        { opacity: 0, x: 30, rotation: 18, transformOrigin: 'bottom right' },
        { opacity: 1, x: 0,  rotation:  0, duration: 0.9,  ease: 'power2.out' }, '-=0.55')

    /* Texte stagger */
      .fromTo('.ts-hs-eyebrow',
        { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 0.55, ease: ease }, '-=0.45')
      .fromTo('.ts-hs-h1',
        { opacity: 0, y: 34 }, { opacity: 1, y: 0, duration: 0.8,  ease: ease }, '-=0.38')
      .fromTo('.ts-hs-desc',
        { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.6,  ease: ease }, '-=0.45')
      .fromTo('.ts-hs-cta .ts-btn',
        { opacity: 0, y: 18 }, { opacity: 1, y: 0, stagger: 0.13, duration: 0.5, ease: ease }, '-=0.4')
      .fromTo('.ts-hs-trust',
        { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.45, ease: ease }, '-=0.25')
      .fromTo('.ts-hs-branch',
        { opacity: 0, x: -15, rotation: -10 },
        { opacity: 0.55, x: 0, rotation: 0, duration: 0.6, ease: 'power2.out' }, '-=0.5');

    /* ─ Étiquette : balance en permanence ─ */
    gsap.to('#ts-hs-tag', {
      rotation: 5,
      duration: 2.6,
      repeat: -1, yoyo: true,
      ease: 'sine.inOut',
      delay: 1.4,
      transformOrigin: 'top center'
    });

    /* ─ Herbes : ondulent dans la brise ─ */
    gsap.to('#ts-hs-grass', {
      rotation: 4,
      duration: 3.2,
      repeat: -1, yoyo: true,
      ease: 'sine.inOut',
      delay: 0.6,
      transformOrigin: 'bottom center'
    });

    /* ─ Pois argile : flottent lentement ─ */
    gsap.utils.toArray('.ts-hs-dot').forEach(function (dot, i) {
      gsap.to(dot, {
        y: -(10 + i * 5),
        duration: 3.2 + i * 0.8,
        repeat: -1, yoyo: true,
        ease: 'sine.inOut',
        delay: i * 0.9
      });
    });

    /* ─ Inclinaison 3D photo au survol souris ─ */
    var media = document.getElementById('ts-hs-media');
    if (media && !window.matchMedia('(pointer: coarse)').matches) {
      media.addEventListener('mousemove', function (e) {
        var r  = media.getBoundingClientRect();
        var dx = (e.clientX - r.left  - r.width  / 2) / r.width;
        var dy = (e.clientY - r.top   - r.height / 2) / r.height;
        gsap.to('.ts-hs-img', {
          rotationY:          dx * 10,
          rotationX:         -dy * 7,
          scale:              1.03,
          duration:           0.4,
          ease:               'power2.out',
          transformPerspective: 900,
          transformOrigin:    'center center'
        });
      });
      media.addEventListener('mouseleave', function () {
        gsap.to('.ts-hs-img', {
          rotationY: 0, rotationX: 0, scale: 1,
          duration: 0.7, ease: 'power2.out'
        });
      });
    }
  }

  /* Scintillement des étoiles via GSAP (cross-browser garanti) */
  function gsapStars() {
    document.querySelectorAll('.ts-star').forEach(function (star) {
      star.style.animation = 'none';
      star.style.opacity   = '0.1';
      gsap.to(star, {
        opacity:  0.45 + Math.random() * 0.45,
        scale:    0.85 + Math.random() * 0.45,
        rotation: -25  + Math.random() * 50,
        duration: 2.5  + Math.random() * 3.5,
        repeat: -1, yoyo: true,
        ease: 'sine.inOut',
        delay: Math.random() * 5
      });
    });
  }

  /* Révélations au scroll (remplace IntersectionObserver) */
  function gsapScrollReveal() {
    // Rendre tous les éléments visibles (CSS les cache via opacity:0 + animation)
    document.querySelectorAll('[data-ts-reveal]').forEach(function (el) {
      el.classList.add('ts-in');
    });
    gsap.utils.toArray('[data-ts-reveal]').forEach(function (el) {
      gsap.fromTo(el,
        { opacity: 0, y: 28 },
        { opacity: 1, y: 0, duration: 0.75, ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' }
        });
    });
  }

  /* Cartes produits et catégories avec stagger */
  function gsapProducts() {
    // Grille produits
    gsap.utils.toArray('.ts-product-grid').forEach(function (grid) {
      gsap.fromTo(grid.querySelectorAll('.ts-product-card'),
        { opacity: 0, y: 38, scale: 0.94 },
        { opacity: 1, y: 0, scale: 1,
          stagger: { amount: 0.45, from: 'start' },
          duration: 0.65, ease: 'power2.out',
          scrollTrigger: { trigger: grid, start: 'top 87%' }
        });
    });
    // Catégories
    gsap.fromTo('.ts-cat-card',
      { opacity: 0, scale: 0.92, y: 18 },
      { opacity: 1, scale: 1, y: 0,
        stagger: 0.09, duration: 0.6, ease: 'back.out(1.3)',
        scrollTrigger: { trigger: '.ts-categories', start: 'top 87%' }
      });
  }

  /* Parallaxe scroll */
  function gsapParallax() {
    if (window.matchMedia('(pointer: coarse)').matches) return;

    /* ── Split hero parallax ── */
    if (document.querySelector('.ts-hero-split')) {
      gsap.to('.ts-hs-media', {
        scrollTrigger: { trigger: '.ts-hero-split', start: 'top top', end: '100% top', scrub: 1.6 },
        y: -90
      });
      gsap.to('#ts-hs-content', {
        scrollTrigger: { trigger: '.ts-hero-split', start: 'top top', end: '80% top', scrub: 1 },
        y: -40, opacity: 0.6
      });
      gsap.to('#ts-hs-grass', {
        scrollTrigger: { trigger: '.ts-hero-split', start: 'top top', end: '100% top', scrub: 2 },
        y: -55, x: 10
      });
    }

    /* Légère parallaxe sur images produit */
    gsap.utils.toArray('.ts-product-card .ts-product-img img').forEach(function (img) {
      gsap.to(img, {
        scrollTrigger: { trigger: img, scrub: 1.2 },
        y: -16, scale: 1.05
      });
    });
  }

  /* Sections — trust bar, reviews, marquee, bundle, etc. */
  function gsapSections() {
    // Trust bar
    gsap.fromTo('.ts-trust-item',
      { opacity: 0, y: 18 },
      { opacity: 1, y: 0, stagger: 0.09, duration: 0.5, ease: 'power2.out',
        scrollTrigger: { trigger: '.ts-trust', start: 'top 90%' }
      });
    // Avis clients
    gsap.utils.toArray('.ts-review-card').forEach(function (card, i) {
      gsap.fromTo(card,
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 0.65, ease: 'power2.out',
          delay: i * 0.08,
          scrollTrigger: { trigger: card, start: 'top 90%' }
        });
    });
    // Matériaux
    gsap.fromTo('.ts-mat-item',
      { opacity: 0, y: 22 },
      { opacity: 1, y: 0, stagger: 0.08, duration: 0.55, ease: 'power2.out',
        scrollTrigger: { trigger: '.ts-materials-grid', start: 'top 88%' }
      });
    // Bundle
    gsap.fromTo('.ts-bundle-wrap',
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out',
        scrollTrigger: { trigger: '.ts-bundle', start: 'top 85%' }
      });
    // Têtes de sections
    gsap.utils.toArray('.ts-section-head').forEach(function (head) {
      gsap.fromTo(Array.from(head.children),
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, stagger: 0.1, duration: 0.6, ease: 'power2.out',
          scrollTrigger: { trigger: head, start: 'top 89%' }
        });
    });
    // Marquee
    gsap.fromTo('.ts-marquee',
      { opacity: 0 },
      { opacity: 1, duration: 0.8,
        scrollTrigger: { trigger: '.ts-marquee', start: 'top 92%' }
      });
    // Newsletter
    gsap.fromTo('.ts-newsletter-inner',
      { opacity: 0, y: 24 },
      { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out',
        scrollTrigger: { trigger: '.ts-newsletter', start: 'top 88%' }
      });
  }

  /* ---- Curseur doré — géré en CSS pur (SVG data URL), pas besoin de JS ---- */
  function initCursor() { /* no-op */ }

  /* ---- Hero cluster parallaxe souris ---- */
  function initHeroParallax() {
    var hero    = document.querySelector('.ts-hero');
    var cluster = document.getElementById('ts-hero-cluster');
    if (!hero || !cluster) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;

    hero.addEventListener('mousemove', function (e) {
      var rect = hero.getBoundingClientRect();
      var dx = (e.clientX - rect.left - rect.width  / 2) / rect.width;
      var dy = (e.clientY - rect.top  - rect.height / 2) / rect.height;
      cluster.style.setProperty('--cluster-x', (dx * 18).toFixed(1) + 'px');
      cluster.style.setProperty('--cluster-y', (dy * 11).toFixed(1) + 'px');
    });

    hero.addEventListener('mouseleave', function () {
      cluster.style.setProperty('--cluster-x', '0px');
      cluster.style.setProperty('--cluster-y', '0px');
    });
  }

  /* ---- Barre de progression au scroll ---- */
  function initScrollProgress() {
    var bar = document.getElementById('ts-progress');
    if (!bar) return;
    window.addEventListener('scroll', function () {
      var pct = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      bar.style.width = Math.min(100, pct) + '%';
    }, { passive: true });
  }

  /* ---- Page loader ---- */
  function initLoader() {
    var loader = document.getElementById('ts-loader');
    if (!loader) return;
    function hide() { loader.classList.add('ts-done'); }
    if (document.readyState === 'complete') {
      setTimeout(hide, 200);
    } else {
      window.addEventListener('load', function () { setTimeout(hide, 250); });
    }
    /* Sécurité : masque après 3s max quoi qu'il arrive */
    setTimeout(hide, 3000);
  }

  /* ---- Tilt 3D sur les cartes produit — RETIRÉ ----

     Ce que faisait cette fonction à chaque mouvement de souris sur une
     carte : un « transform: perspective() rotateX() rotateY() scale3d() »
     ET la réécriture complète du dégradé radial de la lueur. Réécrire un
     dégradé image par image force le navigateur à repeindre la carte
     entière à chaque fois — c'est l'opération la plus coûteuse qu'on
     puisse lui demander.

     Elle n'était pas seule : ts-light, ts-signature et ts-motion posaient
     trois autres effets sur le même nœud. Mesuré sur un téléphone bridé
     quatre fois, un simple défilement du catalogue occupait 97 % du
     processeur.

     Et sur le fond, une photo de bijou qui pivote en 3D au passage de la
     souris relève de la démonstration technique, pas de la bijouterie.
     La nouvelle carte « planche » n'a qu'un mouvement : la seconde photo
     se substitue à la première, et la couture d'or s'allume.

     Le code reste ci-dessous, inerte : « return » avant tout. */
  function initTilt() {
    return;
    /* eslint-disable no-unreachable */
    if (window.matchMedia('(pointer: coarse)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.ts-product-card, .ts-card').forEach(function (card) {
      /* Injecte le glow si absent */
      if (!card.querySelector('.ts-card-glow')) {
        var glow = document.createElement('div');
        glow.className = 'ts-card-glow';
        card.style.position = 'relative';
        card.insertBefore(glow, card.firstChild);
      }
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = e.clientX - r.left;
        var y = e.clientY - r.top;
        var rotX = ((r.height / 2 - y) / r.height) * 13;
        var rotY = ((x - r.width  / 2) / r.width)  * 13;
        card.style.transition = 'box-shadow .3s';
        card.style.transform  =
          'perspective(750px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) scale3d(1.02,1.02,1.02)';
        var glow = card.querySelector('.ts-card-glow');
        if (glow) {
          glow.style.background =
            'radial-gradient(circle at ' + (x / r.width * 100).toFixed(0) + '% ' +
            (y / r.height * 100).toFixed(0) + '%, rgba(176,132,58,.16), transparent 62%)';
        }
      });
      card.addEventListener('mouseleave', function () {
        card.style.transition = 'transform .55s cubic-bezier(.2,.7,.2,1), box-shadow .4s';
        card.style.transform  = '';
      });
    });
  }

  /* ---- Particules ✦ héro (canvas) ---- */
  function initHeroParticles() {
    /* Désactivé — fond hero clair, particules non visibles */
    return;

    var canvas = document.createElement('canvas');
    canvas.id = 'ts-hero-canvas';
    hero.style.position = 'relative'; /* garantit le positionnement */
    hero.prepend(canvas);
    var ctx = canvas.getContext('2d');
    var particles = [];

    function resize() {
      canvas.width  = hero.offsetWidth;
      canvas.height = hero.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize, { passive: true });

    /* Couleurs dorées lumineuses — visibles sur fond sombre */
    var COLORS = [
      'rgba(217,185,112,0.70)',
      'rgba(176,132,58,0.55)',
      'rgba(244,231,207,0.45)',
    ];

    function makeParticle(init) {
      return {
        x:     Math.random() * canvas.width,
        y:     init ? Math.random() * canvas.height : canvas.height + 20,
        size:  10 + Math.random() * 12,
        speed: 0.20 + Math.random() * 0.30,
        opa:   0,
        maxO:  0.65 + Math.random() * 0.25,
        phase: Math.random() * Math.PI * 2,
        color: COLORS[Math.floor(Math.random() * COLORS.length)]
      };
    }
    for (var i = 0; i < 28; i++) particles.push(makeParticle(true));

    (function loop(t) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(function (p) {
        p.y -= p.speed;
        p.x += Math.sin(t * 0.0004 + p.phase) * 0.4;
        if (p.y < canvas.height * 0.8) p.opa = Math.min(p.maxO, p.opa + 0.004);
        if (p.y < 60)  p.opa -= 0.006;
        if (p.opa <= 0 && p.y < 0) { var np = makeParticle(false); p.x=np.x;p.y=np.y;p.size=np.size;p.speed=np.speed;p.opa=0;p.maxO=np.maxO;p.phase=np.phase;p.color=np.color; }
        if (p.opa <= 0) return;
        ctx.save();
        ctx.globalAlpha = p.opa;
        ctx.fillStyle   = p.color;
        ctx.font        = 'bold ' + p.size + 'px "Jost", sans-serif';
        ctx.textAlign   = 'center';
        ctx.fillText('✦', p.x, p.y);
        ctx.restore();
      });
      requestAnimationFrame(loop);
    })(0);
  }

  /* ---- Parallaxe héro (fallback sans GSAP) ---- */
  function initParallax() {
    if (window.gsap) return; // GSAP ScrollTrigger gère le parallaxe
    if (window.matchMedia('(pointer: coarse)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var hero = document.querySelector('.ts-hero');
    if (!hero) return;
    var inner = hero.querySelector('.ts-hero-inner');
    var ghost = hero.querySelector('.ts-hero-ghost');
    if (!inner) return;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > window.innerHeight) return;
      inner.style.transform = 'translateY(' + (y * 0.22) + 'px)';
      inner.style.opacity   = Math.max(0, 1 - (y / (window.innerHeight * 0.75)));
      if (ghost) ghost.style.transform = 'translate(-50%,-50%) translateY(' + (y * 0.08) + 'px)';
    }, { passive: true });
  }

  /* ---- Révélation mot par mot ---- */
  function initWordReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    /*
     * Cible : h2 à l'intérieur de nos sections Ti Solèy
     * + tout élément marqué [data-ts-words] explicitement.
     * On EXCLUT le hero (il a déjà ses propres animations CSS) et les cartes.
     */
    var sel = [
      '.ts-section h2',
      '.ts-section .ts-eyebrow',
      '.ts-cnt-hero h1',
      '.ts-col-banner h1',
      '[data-ts-words]'
    ].join(',');

    document.querySelectorAll(sel).forEach(function (el) {
      if (el.querySelector('.ts-word')) return; /* déjà traité */

      /*
       * Deux garde-fous ajoutés après un dégât réel : les titres de rayon du
       * catalogue portent un soleil en SVG, un nom stylé et une couture
       * animée ; ce découpage reconstruisait leur innerHTML à partir du seul
       * texte et effaçait tout le reste. Le titre s'affichait nu.
       *
       * On ne touche donc plus qu'aux titres réellement faits de texte, et on
       * laisse un moyen de se retirer explicitement. Un titre composé garde
       * sa composition : c'est plus important qu'une animation.
       */
      if (el.hasAttribute('data-ts-nowords')) return;
      if (el.children.length) return;

      /* Découpe le texte en mots en préservant le HTML intérieur simple */
      var text = el.textContent.trim();
      if (!text || text.length < 3) return;
      el.innerHTML = text.replace(/(\S+)/g, function (word) {
        return '<span class="ts-word">' + word + '</span>&nbsp;';
      });
      el.setAttribute('data-ts-words', '');
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var words = entry.target.querySelectorAll('.ts-word');
        words.forEach(function (w, i) {
          w.style.transitionDelay = (i * 50) + 'ms';
        });
        entry.target.classList.add('ts-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.2 });

    document.querySelectorAll('[data-ts-words]').forEach(function (el) { io.observe(el); });
  }

  /* ---- Ripple doré ---- */
  function initRipple() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ts-btn,.ts-btn-gold,.ts-btn-ghost,[data-ts-ripple]');
      if (!btn) return;
      var r  = btn.getBoundingClientRect();
      var rp = document.createElement('span');
      rp.className = 'ts-ripple-wave';
      rp.style.left = (e.clientX - r.left) + 'px';
      rp.style.top  = (e.clientY - r.top)  + 'px';
      /* Assure overflow:hidden */
      if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
      btn.appendChild(rp);
      setTimeout(function () { if (rp.parentNode) rp.parentNode.removeChild(rp); }, 700);
    });
  }

  /* ---- Boutons magnétiques ---- */
  function initMagnetic() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.ts-btn,.ts-btn-gold,.ts-btn-ghost,[data-ts-magnet]').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = e.clientX - (r.left + r.width  / 2);
        var y = e.clientY - (r.top  + r.height / 2);
        btn.style.transition = 'transform .18s, box-shadow .3s';
        btn.style.transform  = 'translate(' + (x * 0.27) + 'px,' + (y * 0.27) + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transition = 'transform .5s cubic-bezier(.2,.7,.2,1), box-shadow .3s';
        btn.style.transform  = '';
      });
    });
  }

  /* ---- Toast panier premium ---- */
  var tsToastTimer = null;

  function showCartToast(name, imgSrc, cartUrl) {
    var wrap = document.getElementById('ts-toast-wrap');
    if (!wrap) return;

    /* Vide toute notification existante */
    wrap.innerHTML = '';
    clearTimeout(tsToastTimer);

    var toast = document.createElement('div');
    toast.className = 'ts-toast';
    var imgHtml = imgSrc
      ? '<img src="' + imgSrc + '" alt="" loading="lazy">'
      : '✦';
    toast.innerHTML =
      '<div class="ts-toast-thumb">' + imgHtml + '</div>' +
      '<div class="ts-toast-body">' +
        '<div class="ts-toast-name">' + name + '</div>' +
        '<div class="ts-toast-sub">Ajouté au panier</div>' +
      '</div>' +
      '<a href="' + (cartUrl || '/cart') + '" class="ts-toast-link">Voir →</a>';
    wrap.appendChild(toast);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.classList.add('ts-in'); });
    });

    tsToastTimer = setTimeout(function () {
      toast.classList.remove('ts-in');
      setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 500);
    }, 3800);
  }

  /* ---- Burst ✦ wishlist ---- */
  function initWishlistBurst() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ts-wish');
      if (!btn) return;
      /* N'explose que quand on ajoute (pas quand on retire) */
      if (!btn.classList.contains('ts-active')) return;
      var r  = btn.getBoundingClientRect();
      var cx = r.left + r.width  / 2;
      var cy = r.top  + r.height / 2;
      var chars = ['✦','♡','✦','·','✦','♡'];
      chars.forEach(function (ch, i) {
        var p = document.createElement('span');
        p.className = 'ts-burst-p';
        p.textContent = ch;
        var angle = (i / chars.length) * Math.PI * 2;
        var dist  = 38 + Math.random() * 28;
        p.style.setProperty('--tx', Math.cos(angle) * dist + 'px');
        p.style.setProperty('--ty', Math.sin(angle) * dist + 'px');
        p.style.left = cx + 'px'; p.style.top = cy + 'px';
        document.body.appendChild(p);
        setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 750);
      });
    });
  }

  /* ---- Add-to-cart via Fetch (pour les cartes produit simple variante) ---- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ts-add]');
      if (!btn) return;
      var variantId = btn.dataset.tsAdd;
      if (!variantId) return;

      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = '…';

      fetch(window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          /* Toast premium */
          var imgSrc = item.image ? item.image : null;
          showCartToast(item.product_title || item.title, imgSrc, '/cart');

          /* Rafraîchit le cart drawer Dawn */
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) { drawer.renderContents({ cart: cart }); });
          }

          btn.textContent = '✓';
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1600);
        })
        .catch(function () {
          btn.textContent = orig;
          btn.disabled = false;
        });
    });
  }

  /* ---- Catalogue Netflix : flèches de défilement horizontal ---- */
  function initNetflixScroll() {
    document.querySelectorAll('.ts-nx-row').forEach(function (row) {
      var scroll = row.querySelector('.ts-nx-scroll');
      var prev   = row.querySelector('.ts-nx-prev');
      var next   = row.querySelector('.ts-nx-next');
      if (!scroll) return;

      var cardW = 238; /* largeur carte + gap estimée */

      function scrollBy(dir) {
        var amount = Math.max(1, Math.floor(scroll.clientWidth / cardW)) * cardW;
        scroll.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
      if (next) next.addEventListener('click', function () { scrollBy(1); });

      function updateArrows() {
        var atStart = scroll.scrollLeft <= 2;
        var atEnd   = scroll.scrollLeft >= scroll.scrollWidth - scroll.clientWidth - 4;
        if (prev) prev.classList.toggle('ts-nx-btn-hidden', atStart);
        if (next) next.classList.toggle('ts-nx-btn-hidden', atEnd);
      }

      scroll.addEventListener('scroll', updateArrows, { passive: true });
      /* Init après premier rendu */
      requestAnimationFrame(updateArrows);

      /* Swipe tactile (tablettes) */
      var startX;
      scroll.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      scroll.addEventListener('touchend', function (e) {
        if (startX == null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) scrollBy(dx < 0 ? 1 : -1);
        startX = null;
      }, { passive: true });
    });
  }

  /* ---- Page panier : quantité + suppression via AJAX ---- */
  function initCartPage() {
    if (!document.querySelector('.ts-cart-items-col')) return;

    /* La section ts-cart embarque désormais son propre gestionnaire : mise à
       jour immédiate de l’affichage, puis requête en arrière-plan, sans
       rechargement. Celui-ci ne sert plus que de filet si la section était
       remplacée un jour. Sans cette sortie, les deux se déclenchent sur le même
       clic — et comme la section vient de réécrire data-qty, celui-ci lit la
       valeur déjà décrémentée et retire un article de trop. */
    if (window.__tsCartV2) return;

    function cartChange(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
      })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
    }

    /* Stepper quantité */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ts-ci-step');
      if (!btn) return;
      var key = btn.dataset.key;
      var qty = parseInt(btn.dataset.qty, 10);
      cartChange(key, qty);
    });

    /* Bouton supprimer */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ts-cart-remove-btn');
      if (!btn) return;
      var key = btn.dataset.key;
      /* Animation sortie */
      var item = btn.closest('.ts-cart-item');
      if (item) { item.style.transition = 'opacity .3s, transform .3s'; item.style.opacity = '0'; item.style.transform = 'translateX(24px)'; }
      setTimeout(function () { cartChange(key, 0); }, 280);
    });

    /* Synchronise la note cadeau */
    var noteArea = document.getElementById('ts-cart-note');
    if (noteArea) {
      var noteTimer;
      noteArea.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: noteArea.value })
          });
        }, 800);
      });
    }
  }

  /* ---- Page produit complète ---- */
  function initProductPage() {
    var form = document.getElementById('ts-pdp-form');
    if (!form) return;

    var variantInput = document.getElementById('ts-variant-id');
    var addBtn       = document.querySelector('.ts-pdp-add-btn');
    var qtyVal       = document.querySelector('.ts-pdp-qty-val');
    var mainImg      = document.getElementById('ts-pdp-main-img');
    var variantsJSON = document.getElementById('ts-variants-json');
    var variants     = variantsJSON ? JSON.parse(variantsJSON.textContent || '[]') : [];

    /* Galerie : clic sur miniature */
    document.querySelectorAll('.ts-pdp-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('.ts-pdp-thumb').forEach(function (t) { t.classList.remove('ts-pdp-thumb--active'); });
        thumb.classList.add('ts-pdp-thumb--active');
        if (mainImg) {
          mainImg.style.opacity = '0';
          setTimeout(function () {
            mainImg.src    = thumb.dataset.src || mainImg.src;
            mainImg.srcset = thumb.dataset.srcset || '';
            mainImg.alt    = thumb.dataset.alt || mainImg.alt;
            mainImg.style.opacity = '1';
          }, 200);
        }
      });
    });

    /* Sélection de variant */
    function getSelectedOptions() {
      var opts = {};
      document.querySelectorAll('.ts-pdp-opt-btn.ts-pdp-opt-active').forEach(function (btn) {
        opts[btn.dataset.optIndex] = btn.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] == null || opts[i] === o; });
      });
    }

    function updateVariant() {
      var opts    = getSelectedOptions();
      var variant = findVariant(opts);
      if (!variant) return;
      variantInput.value = variant.id;
      /* Prix */
      var priceEl   = document.querySelector('.ts-pdp-price');
      var compareEl = document.querySelector('.ts-pdp-compare');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      /* Dispo */
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Ajouter au panier' : 'Indisponible';
      }
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    }

    document.querySelectorAll('.ts-pdp-opt-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.ts-pdp-opt-values');
        if (group) group.querySelectorAll('.ts-pdp-opt-btn').forEach(function (b) { b.classList.remove('ts-pdp-opt-active'); });
        btn.classList.add('ts-pdp-opt-active');
        updateVariant();
      });
    });

    /* Quantité */
    document.querySelectorAll('.ts-pdp-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = parseInt(qtyVal ? qtyVal.value : 1, 10) || 1;
        var dir     = parseInt(btn.dataset.dir, 10);
        var next    = Math.max(1, current + dir);
        if (qtyVal) qtyVal.value = next;
      });
    });

    /* Accordéons */
    document.querySelectorAll('.ts-pdp-accord-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        var body = btn.nextElementSibling;
        if (body) body.classList.toggle('ts-open', !expanded);
      });
    });

    /* AJAX add-to-cart */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var varId = parseInt(variantInput ? variantInput.value : 0, 10);
      var qty   = parseInt(qtyVal ? qtyVal.value : 1, 10) || 1;
      if (!varId) return;
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = '…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: varId, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        showCartToast(item.product_title || item.title, item.image || null, '/cart');
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Ajouté ✓'; setTimeout(function () { addBtn.textContent = 'Ajouter au panier'; }, 1800); }
      })
      .catch(function () { if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Ajouter au panier'; } });
    });

    /* Wishlist btn sur page produit */
    var wishBtn   = document.querySelector('.ts-pdp-wish-btn');
    var productId = wishBtn ? parseInt(wishBtn.dataset.productId, 10) : 0;
    if (wishBtn && productId) {
      var wl = JSON.parse(localStorage.getItem('ts_wishlist') || '[]');
      if (wl.includes(productId)) wishBtn.classList.add('ts-pdp-wish-active');
      wishBtn.addEventListener('click', function () {
        var list = JSON.parse(localStorage.getItem('ts_wishlist') || '[]');
        if (list.includes(productId)) {
          list = list.filter(function (id) { return id !== productId; });
          wishBtn.classList.remove('ts-pdp-wish-active');
        } else {
          list.push(productId);
          wishBtn.classList.add('ts-pdp-wish-active');
          burstEffect(wishBtn);
        }
        localStorage.setItem('ts_wishlist', JSON.stringify(list));
        updateWishlistCount();
      });
    }
  }

  /* ---- FAQ accordéons ---- */
  function initFaqAccordions() {
    document.querySelectorAll('.ts-faq-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        /* Ferme tous les autres dans la même catégorie */
        var category = btn.closest('.ts-faq-category');
        if (category) {
          category.querySelectorAll('.ts-faq-btn[aria-expanded="true"]').forEach(function (b) {
            if (b !== btn) {
              b.setAttribute('aria-expanded', 'false');
              var ob = b.nextElementSibling;
              if (ob) ob.classList.remove('ts-open');
            }
          });
        }
        btn.setAttribute('aria-expanded', String(!expanded));
        var body = btn.nextElementSibling;
        if (body) body.classList.toggle('ts-open', !expanded);
      });
    });
  }

  /* ---- Size guide tabs ---- */
  function initSizeGuideTabs() {
    var tabs   = document.querySelectorAll('.ts-sguide-tab');
    var panels = document.querySelectorAll('.ts-sguide-panel');
    if (!tabs.length) return;
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('ts-sguide-tab--active'); });
        panels.forEach(function (p) { p.classList.remove('ts-sguide-panel--active'); });
        tab.classList.add('ts-sguide-tab--active');
        if (panels[i]) panels[i].classList.add('ts-sguide-panel--active');
      });
    });
  }

  /* ---- Quick-add depuis page recherche (data-product-url) ---- */
  function initSearchQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ts-quick-add-btn');
      if (!btn || !btn.dataset.variantId) return;
      var variantId = btn.dataset.variantId;
      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        showCartToast(item.product_title || item.title, item.image || null, '/cart');
        btn.textContent = '✓';
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1600);
      })
      .catch(function () { btn.textContent = orig; btn.disabled = false; });
    });
  }

  /* ---- Init ---- */
  document.addEventListener('DOMContentLoaded', function () {
    initLoader();
    initCursor();
    initHeroParallax();
    initScrollProgress();
    initAnnounceBar();
    initHeaderScroll();
    initScrollReveal();
    initWordReveal();
    initMobileMenu();
    initWishlist();
    initWishlistBurst();
    initShippingBar();
    initQuickAdd();
    initSearchQuickAdd();
    initCartPage();
    initProductPage();
    initFaqAccordions();
    initSizeGuideTabs();
    initNetflixScroll();
    initRipple();
    initMagnetic();
    initTilt();
    initHeroParticles();
    initParallax();
    initPopup();
    // GSAP : appelé après que le DOM est prêt, GSAP chargé via defer avant ce script
    if (document.readyState === 'complete') {
      initGSAP();
    } else {
      window.addEventListener('load', initGSAP);
    }
  });
})();
